import { configureStore, getDefaultMiddleware } from 'redux-starter-kit'
import {combineEpics, createEpicMiddleware} from 'redux-observable'
import mapDuck from './mapDuck'
import {firestoreReducer} from 'redux-firestore'
import changes from './changesDuck'
import tableDuck from './tableDuck'
import {changesEpic, changeLayerEpic} from "./changesEpic";
import  firebase from "./firebase"

const firestore = firebase.firestore()




const rootEpic = (...args) =>
  combineEpics(changesEpic, changeLayerEpic)(...args, firestore)

const epicMiddleware = createEpicMiddleware()


const store = configureStore({
    reducer: {map: mapDuck.reducer,
    changes: changes.reducer,
        firestore: firestoreReducer,
        table: tableDuck.reducer
},
    middleware: [epicMiddleware],
    devTools: true
});

epicMiddleware.run(rootEpic)
export default store



// WEBPACK FOOTER //
// ./src/redux/store.js